import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import InboxRepository from "../../../repositories/inbox-repository";
import { InboxList } from "../list/interface";
import { Inbox } from "../../../models/inbox";

export const useGetInbox = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<InboxList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [inboxData, setInboxData] = useState<Inbox | null>(null);
  const [isOnFetchingInboxData, setIsOnFetchingInboxData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await InboxRepository.all(params)
      .then((response: AxiosResponse<ICollection<InboxList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadInboxData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingInboxData(true);

      await InboxRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Inbox>>) => {
          setInboxData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingInboxData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadInboxData,
    isOnFetchingInboxData,
    inboxData,
  };
};
